import React from 'react';
import Chip from '@material-ui/core/Chip';
import { RxOrderStatusEnum } from 'openapi';

interface Props {
    status: string | undefined,
    orderId?: number,
    handleStatus?: (orderId: number) => void,
}

export default ((props) => {
    if (props.status === undefined) {
        return <></>;
    }

    var style = { backgroundColor: 'grey', color: 'white', label: 'Waiting' };

    switch (props.status) {
        case RxOrderStatusEnum.Success:
            style = { backgroundColor: '#4caf50', color: 'white', label: 'Success' };
            break;
        case RxOrderStatusEnum.Requesting:
            style = { backgroundColor: '#ffeb3b', color: 'black', label: 'Requesting' };
            break;
        case RxOrderStatusEnum.Error:
            style = { backgroundColor: '#f44336', color: 'white', label: 'Error' };
            break;
        case RxOrderStatusEnum.EmailSent:
            style = { backgroundColor: '#44abe3', color: 'white', label: 'Email Sent' };
            break;
        case RxOrderStatusEnum.WaitingResponse:
            style = { backgroundColor: '#7877bd', color: 'white', label: 'Waiting Response' };
            break;
        case RxOrderStatusEnum.InProgress:
            style = { backgroundColor: '#b86780', color: 'white', label: 'In Progress' };
            break;
        case RxOrderStatusEnum.Dispatched:
            style = { backgroundColor: '#e0a846', color: 'white', label: 'Dispatched' };
            break;
    }

    return (
        <Chip
            size="small"
            style={{ color: style.color, backgroundColor: style.backgroundColor }}
            label={style.label}
            onClick={() => props.handleStatus && props.status !== RxOrderStatusEnum.Waiting ? props.handleStatus(props.orderId ? props.orderId : -1) : undefined} />)
}) as React.FC<Props>